import graphql from "babel-plugin-relay/macro";
import { atom, useAtomValue } from "jotai";
import { useFragment } from "react-relay";

import { VerificationModalStepStateAtom } from "../../../../atoms/stores";
import { AccountCreationForm } from "./AccountCreationForm";
import { AccountCreationStepFragment_session$key } from "./__generated__/AccountCreationStepFragment_session.graphql";

const AccountCreationDataAtom = atom((get) => {
  const state = get(VerificationModalStepStateAtom);
  if (state.step === "AccountCreation") {
    return {
      email: state.verifiedEmail,
      phone: state.verifiedPhone,
    };
  }

  return {};
});

export const AccountCreationStep = ({
  sessionRef,
  hasAuthenticatedUser,
}: {
  sessionRef: AccountCreationStepFragment_session$key | null;
  hasAuthenticatedUser: boolean;
}) => {
  const { email, phone } = useAtomValue(AccountCreationDataAtom);
  const verifiedContactMethod = phone && phone.length > 0 ? "phone" : "email";
  const session = useFragment(AccountCreationStepFragmentString, sessionRef);
  const club = session?.currentClientProfile?.member?.club;
  const { clubPolicyLink, name } = club ?? {};
  return (
    <AccountCreationForm
      hasAuthenticatedUser={hasAuthenticatedUser}
      clubPolicyLink={clubPolicyLink}
      clubName={name}
      defaultCountryCodeId={club?.defaultCountryCode || "US"}
      initialEmail={email ?? undefined}
      initialPhone={phone ?? undefined}
      shouldShowAnalyticsTrackingConsent={
        session?.requiresAnalyticsTrackingConsent ?? false
      }
      verifiedContactMethod={verifiedContactMethod}
    />
  );
};
export const AccountCreationStepFragmentString = graphql`
  fragment AccountCreationStepFragment_session on Session {
    requiresAnalyticsTrackingConsent
    ...useSyncAnalyticsTrackingPermission_session
    currentClientProfile {
      member {
        club {
          name
          clubPolicyLink
          defaultCountryCode
        }
      }
    }
  }
`;
